import { PageLoading } from 'components/loading'
import { useHistoricoAtividadeColetivaReuniaoQuery } from 'graphql/hooks.generated'
import { IdadeOrigemAtendimento } from 'view/atendimentos/detail/historico/model/model-historico'

import HistoricoNoDetailAvailable from '../../HistoricoNoDetailAvailable'
import HistoricoAtividadeColetivaPanelReuniao from './HistoricoAtividadeColetivaPanelReuniao'

interface HistoricoAtividadeColetivaPecPanelReuniaoProps {
  readonly idAtividadeColetiva: ID
  readonly idadeOrigemAtendimento: IdadeOrigemAtendimento
  readonly cidadaoId: ID
}

export default function HistoricoAtividadeColetivaPecPanelReuniao({
  idAtividadeColetiva,
  idadeOrigemAtendimento,
  cidadaoId,
}: HistoricoAtividadeColetivaPecPanelReuniaoProps) {
  const {
    data: { atividadeColetiva },
    loading,
  } = useHistoricoAtividadeColetivaReuniaoQuery({
    variables: { atividadeColetivaId: idAtividadeColetiva, cidadaoId },
  })

  if (loading) {
    return <PageLoading message='Carregando...' />
  } else if (!atividadeColetiva) {
    return <HistoricoNoDetailAvailable />
  } else {
    return (
      <HistoricoAtividadeColetivaPanelReuniao
        atividadeColetiva={atividadeColetiva}
        idadeOrigemAtendimento={idadeOrigemAtendimento}
      />
    )
  }
}
